module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=AG - Antigua and Barbuda.e589c76c.svg";